import { api } from './api-client';

export type AttendanceStatus =
  | 'NORMAL'
  | 'LATE'
  | 'EARLY_LEAVE'
  | 'ABSENT'
  | 'OVERTIME';

export interface TodayAttendance {
  employeeId: string;
  date: string;
  clockIn: string | null;
  clockOut: string | null;
  status: AttendanceStatus;
  lateMinutes?: number;
  earlyMinutes?: number;
}

export async function fetchTodayStatus(employeeId: string): Promise<TodayAttendance | null> {
  const { data } = await api.get<TodayAttendance | null>(
    `/hrm/attendance/today/${employeeId}`,
  );
  return data;
}

export interface ClockMeta {
  lat?: number;
  lng?: number;
  source?: 'MOBILE' | 'MANUAL';
}

export async function clockIn(meta?: ClockMeta): Promise<TodayAttendance> {
  const { data } = await api.post<TodayAttendance>(
    `/hrm/attendance/clock-in`,
    { source: 'MOBILE', ...meta },
  );
  return data;
}

export async function clockOut(meta?: ClockMeta): Promise<TodayAttendance> {
  const { data } = await api.post<TodayAttendance>(
    `/hrm/attendance/clock-out`,
    { source: 'MOBILE', ...meta },
  );
  return data;
}
